import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { formatDate } from "@/utils/dateFormatter";
import { startOfWeek, endOfWeek } from "date-fns";
import { CalendarViewMode } from "./types";
import { ReactNode } from "react";

interface CalendarHeaderProps {
	currentDate: Date;
	viewMode: CalendarViewMode;
	onNavigate: (direction: "prev" | "next") => void;
	onViewModeChange: (mode: CalendarViewMode) => void;
	onTodayClick: () => void;
	actions?: ReactNode;
}

export const CalendarHeader = ({
	currentDate,
	viewMode,
	onNavigate,
	onViewModeChange,
	onTodayClick,
	actions
}: CalendarHeaderProps) => {
	const getHeaderTitle = () => {
		if (viewMode === "day") {
			return formatDate(currentDate);
		} else if (viewMode === "week") {
			const weekStart = startOfWeek(currentDate, { weekStartsOn: 1 });
			const weekEnd = endOfWeek(currentDate, { weekStartsOn: 1 });
			return `${formatDate(weekStart)} - ${formatDate(weekEnd)}`;
		} else {
			return new Intl.DateTimeFormat('en-US', { 
				month: 'long', 
				year: 'numeric' 
			}).format(currentDate);
		}
	};

	return (
		<div className="flex items-center justify-between mb-4 px-4">
			<div className="flex items-center space-x-2">
				<Button 
					variant="outline" 
					size="sm" 
					onClick={() => onNavigate("prev")}
				>
					<ChevronLeft className="h-4 w-4" />
				</Button>
				
				<div className="text-lg font-medium">
					{getHeaderTitle()}
				</div>
				
				<Button 
					variant="outline" 
					size="sm" 
					onClick={() => onNavigate("next")}
				>
					<ChevronRight className="h-4 w-4" />
				</Button>
				
				<Button 
					variant="outline" 
					size="sm"
					onClick={onTodayClick}
				>
					Today
				</Button>
			</div>
			
			{actions}
		</div>
	);
};
